import React from 'react';
import Logout from '../../components/authentication/Logout';

const PageVerlopen: React.FC = () => (
  <>
    <header className="app-header container">
      <h1>Geldigheid van uw login is verlopen</h1>
      <p className="header-sub-title">
        U wordt automatisch uitgelogd, omdat de geldigheid van uw login is verlopen. Om door te gaan met uw infraplannen.nl kunt u opnieuw inloggen.
      </p>
    </header>
    
    <Logout />
  </>
);

export default PageVerlopen;